import axios from 'axios'

// axios实例
const instance = axios.create({
  // 基础请求路径
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})

// 请求拦截
instance.interceptors.request.use()
// 响应拦截
instance.interceptors.response.use((res) => {
  // 将所有返回数据都统一解构出一层
  const { data: response } = res
  return response
}, (err) => {
  return Promise.reject(err)
})

export default instance
